import ScrubberBar from "@app/analytics/components/ScrubberBar";
import { SPACING as CHART_SPACING } from "@app/analytics/MeetingReport/components/MultipleTimeSeriesChart";
import useMeetingReportHighlights from "@app/analytics/MeetingReport/hooks/useMeetingReportHighlights";
import useTranscript from "@app/analytics/MeetingReport/hooks/useTranscript";
import useVideoStore from "@app/analytics/MeetingReport/stores/video";

import Stack from "@rui/Stack";

const DeepDiveChartScrubber = ({ duration }: { duration: number }) => {
  const { blocks, markers } = useMeetingReportHighlights();
  const { segments } = useTranscript();

  const { currentTimestamp, playbackEnabled, setVideoStartAt } = useVideoStore(
    (state) => ({
      currentTimestamp: state.currentTimestamp,
      playbackEnabled: state.playbackEnabled,
      setVideoStartAt: state.setVideoStartAt,
    })
  );

  const handleClick = playbackEnabled
    ? (timestamp: number) => setVideoStartAt(timestamp)
    : undefined;

  return (
    <Stack sx={{ pt: 2, pr: `${CHART_SPACING.right}px` }}>
      <ScrubberBar
        blocks={blocks}
        currentTime={currentTimestamp}
        duration={duration}
        markers={markers}
        onChange={handleClick}
        onClickBlockOrMarker={handleClick}
        segments={segments}
      />
    </Stack>
  );
};

export default DeepDiveChartScrubber;
